import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, Sparkles, Copy, Check } from 'lucide-react';
import { MYSTERY_IMAGE } from '../mock';
import { toast } from 'sonner';

const COUPON = 'WELCOME5';
const COUPON_PCT = 5;

const MysteryModal = () => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const seen = sessionStorage.getItem('k_welcome_seen');
    if (seen) return;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem('k_welcome_seen', '1');
    setOpen(false);
  };

  const copyAndGo = async () => {
    // Copy to clipboard (best effort)
    try {
      await navigator.clipboard.writeText(COUPON);
    } catch (e) {
      // ignore — we still proceed
    }
    setCopied(true);
    toast.success(`Coupon ${COUPON} copied`);

    // Flag so the product page autofills + auto-applies the coupon
    sessionStorage.setItem('k_prefill_coupon', COUPON);
    sessionStorage.setItem('k_welcome_seen', '1');

    // Slight delay so the user sees the "Copied" state
    setTimeout(() => {
      setOpen(false);
      if (location.pathname !== '/products/korean-scalp-revival-bar') {
        navigate('/products/korean-scalp-revival-bar#bundles');
      } else {
        // Already on PDP — dispatch event to scroll + autofill
        window.dispatchEvent(new CustomEvent('k:apply-prefill-coupon'));
      }
    }, 350);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
      onClick={close}
    >
      <div
        className="relative w-full max-w-[860px] rounded-3xl overflow-hidden flex flex-col md:flex-row fade-up"
        style={{ backgroundColor: '#F5EDDF' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          className="absolute top-3 right-3 rounded-full w-9 h-9 flex items-center justify-center z-10"
          style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
          aria-label="Close"
        >
          <X size={18} />
        </button>

        {/* Left content */}
        <div className="p-8 md:p-10 flex-1 flex flex-col justify-center">
          <div className="flex items-center gap-2">
            <Sparkles size={18} color="#2D5A3D" />
            <span className="text-[11px] tracking-[0.22em] uppercase font-semibold" style={{ color: '#2D5A3D' }}>
              Welcome gift
            </span>
          </div>

          <h2
            className="font-serif text-[40px] md:text-[52px] leading-[1.05] mt-3"
            style={{ color: '#2C2418' }}
          >
            Congratulations!
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed" style={{ color: '#2C2418' }}>
            Here's <b>{COUPON_PCT}% off</b> your first K-Root ritual. Copy your code and reveal the final price on the bundle of your choice.
          </p>

          {/* Coupon code chip with copy button */}
          <div
            className="mt-6 flex items-stretch rounded-2xl overflow-hidden"
            style={{ backgroundColor: '#FFFFFF', border: '2px dashed #2D5A3D' }}
          >
            <div className="flex-1 px-5 py-4 flex items-center">
              <p className="text-[22px] md:text-[26px] font-bold tracking-[0.16em]" style={{ color: '#2D5A3D' }}>
                {COUPON}
              </p>
            </div>
            <button
              onClick={copyAndGo}
              className="px-5 md:px-6 flex items-center gap-2 text-[12px] uppercase tracking-[0.15em] font-bold btn-hover"
              style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
            >
              {copied ? <Check size={16} /> : <Copy size={16} />}
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>

          <button
            onClick={copyAndGo}
            className="mt-4 w-full py-4 rounded-full text-[13px] tracking-[0.18em] uppercase font-bold btn-hover"
            style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
          >
            Copy code & shop now
          </button>

          <button onClick={close} className="mt-3 text-[12px] underline underline-offset-4 opacity-70" style={{ color: '#2C2418' }}>
            No thanks, I'll pay full price
          </button>
        </div>

        {/* Right image */}
        <div className="hidden md:block w-[42%] relative">
          <img src={MYSTERY_IMAGE} alt="K-Root welcome" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
};

export default MysteryModal;
